<template>     
    <span v-if="results > 0" class="u-text-upper u-text-h6">{{ results }} {{ label }}</span>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    props: {
        singularLabel: {
            type: String,
            default: 'Result'
        },
        multiLabel: {
            type: String,
            default: 'Results'
        }
    },
    computed: {
        label() {
            return this.results === 1 ? this.singularLabel: this.multiLabel
        },
        results() {
            return this.getResultsCount()
        }
    },
    methods: {
        ...mapGetters(['getResultsCount'])
    }
}
</script>